import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#121212",
      d: "M11.25 2.25c.41 0 .75.34.75.75v3h6.38c.21 0 .41.09.55.25L22.31 10c.25.28.25.72 0 1l-3.38 3.75a.73.73 0 0 1-.55.25H12v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-6H3c-.4 0-.78-.16-1.06-.44s-.44-.66-.44-1.06v-6c0-.4.16-.78.44-1.06S2.6 6 3 6h7.5V3c0-.41.34-.75.75-.75M3 7.5v6h15.04l2.7-3-2.7-3z"
    }, null, -1)
  ]))]))
}
export default { render: render }